export default __webpack_public_path__ + "static/media/letyoursoulsing.54c204d8.gif";